import Request from "./request";

export default function($app) {
	const self = this;

	const $ui = $app.require('ui');
	const $locale = $app.require('locale');

	self.title = ko.observable($locale.get('information.title'));
	self.name = 'information';
	self.position = ko.computed(function() { return $app.event().moduleInformation.position(); });
	self.isEnabled = ko.computed(function() {
		const landingWatchKeys = [
			'ef74xk6s',
			'efoi4gma',
			'euhvad8v',
			'ekta42w6',
			'exbcj8cq',
			'ezdt60hi',
			'egx0jxgt',
			'ecc2cjd7',
			'ehot229t',
			'ev9mle63',
			'en8yucfv',
			'exslowjj',
			'ee02sai8',
			'ee4unnxd',
			'ec8n652p',
			'ejnz0wdk',
		];
		if (landingWatchKeys.indexOf($app.event().eventKey()) >= 0) {
			return false;
		}
		return !$app.episode() && $app.event().moduleInformation.text() && !(Request.params['hideFooter'] && self.position() === 'bottom');
	});

	self.init = function() {};

	$app.on('start', function() {
		if(self.isEnabled()) {
			self.uiTab = new $ui.Tab(self);

			setTimeout(function() {
				self.init();
			}, 0);
		}
	});
};
